import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import AddChapter from "../../../containers/admin/chapters/models/add-chapter";
import SearchBar from "../../../containers/admin/chapters/searchbar";
import ChaptersTable from "../../../containers/admin/chapters/table";

import { getAllChaptersRequest } from "../../../modules/admin-modules/chapters/Actions";
import { getAllAdminSectionsRequest } from "../../../modules/admin-modules/sections/Actions";

const Chapters = ({ activeFilter = 1, title = "الفصول" }) => {
  const dispatch = useDispatch();
  const model = useSelector((state) => state.model);
  const [isAdd, setAdd] = useState(false);
  const [selectedData, setSelectedData] = useState({});

  useEffect(() => {
    dispatch(getAllChaptersRequest({ active: activeFilter }));
    dispatch(getAllAdminSectionsRequest());
  }, [activeFilter]);

  return (
    <Layout>
      <SearchBar
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        title={title}
        activeFilter={activeFilter}
      />
      <ChaptersTable
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        activeFilter={activeFilter}
      />
      <AddChapter
        isAdd={isAdd}
        data={selectedData}
        setSelectedData={setSelectedData}
        active={activeFilter}
      />
    </Layout>
  );
};

export default Chapters;
